










import { Component, Vue } from 'vue-property-decorator';
import 'splitpanes/dist/splitpanes.css';
import ConsistencyMatrices from '../components/consistency-matrices.vue';

@Component({
  components: { ConsistencyMatrices },
})
export default class ConsistencyView extends Vue {
  mounted(): void {
    console.log(`ConsistencyView mounted`);
  }
}
